import { render, staticRenderFns } from "./user_home_remind.vue?vue&type=template&id=4499a59f&scoped=true&"
import script from "./user_home_remind.vue?vue&type=script&lang=js&"
export * from "./user_home_remind.vue?vue&type=script&lang=js&"
import style0 from "./user_home_remind.vue?vue&type=style&index=0&id=4499a59f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4499a59f",
  null
  
)

export default component.exports